import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";
import checkPermission from "../../Components/Hooks/PermissionHook";
import { setBreadcrumb } from "../../slices/auth/menu/reducer";

/**
* Campaign component representing the main Campaign page.
* This component displays a layout for various Campaign sections such as
* personal details, change password, company details, user list, and privacy policy.
* @component
*/
function Campaigns() {
  document.title = "Campaigns | Adcropper";
  return (
    <React.Fragment>
      {/* <BreadCrumb title={"Ad Library"} pageTitle={"Pages"} /> */}
      <Row>
        <Col xxl={12}>
          <Outlet />
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default Campaigns;